import { CommunityRequestTypesContext } from "../components/context/community-request-types-context";
import { useContext } from "react";

export const useCommunityRequestTypes = () => useContext(CommunityRequestTypesContext);